import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import '@coreui/coreui/dist/css/coreui.min.css'
import store, { persistor } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { MsalProvider } from './auth/msal'
import { registerLicense } from '@syncfusion/ej2-base'

registerLicense(`${import.meta.env.VITE_SYNCFUSION_LIC_KEY}`)

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <MsalProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </MsalProvider>,
)
